import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "./api";

// System-weite Fahrzeug-Kategorien (Admin-Schalter). Standard: nur Motorrad.
const DEFAULT = { motorrad: true, fahrrad: false, auto: false };

const SystemConfigContext = createContext({ ...DEFAULT, loaded: false, refresh: () => {} });

export function SystemConfigProvider({ children }) {
    const [cats, setCats] = useState(DEFAULT);
    const [loaded, setLoaded] = useState(false);

    const refresh = useCallback(async () => {
        try {
            const { data } = await api.get("/system/vehicle-categories");
            setCats({
                motorrad: data?.motorrad !== false,
                fahrrad: !!data?.fahrrad,
                auto: !!data?.auto,
            });
        } catch {
            // Netzwerkfehler → Default beibehalten (Motorrad an).
        } finally {
            setLoaded(true);
        }
    }, []);

    useEffect(() => { refresh(); }, [refresh]);

    return (
        <SystemConfigContext.Provider value={{ ...cats, loaded, refresh }}>
            {children}
        </SystemConfigContext.Provider>
    );
}

// { motorrad, fahrrad, auto, loaded, refresh } — motorrad→category "motorcycle", fahrrad→"bicycle".
export function useVehicleCategories() {
    return useContext(SystemConfigContext);
}
